export default {
  'success.title': 'Paid',
  'success.message': 'Payment successful.',
  'success.closeBtn': 'Close',
  'error.title': 'Notice',
  'error.scanToEnter': 'Please scan QR code again.',
  'oauth.redirecting': 'Redirecting...',
  'index.welcome': 'Cashier',
  'index.scanHint1': 'Please scan',
  'index.scanHint2': 'with mobile',
  'pay.headerPayTo': 'Pay to',
  'pay.amountPlaceholder': 'Enter amount',
  'pay.alipayPlus': 'Alipay+',
  'pay.wxpay': 'WeChat Pay',
  'pay.remarkEdit': 'Edit',
  'pay.remarkAdd': 'Add note',
  'pay.payButton': 'Pay',
  'pay.alertSuccess': 'Paid!',
  'pay.alertCancelled': 'Cancelled',
  'pay.alertFailed': 'Payment failed:',
  'pay.alertMissingParam': 'Missing param',
  'dialog.title': 'Note',
  'dialog.placeholder': 'Max 12 chars',
  'dialog.cancel': 'Cancel',
  'dialog.confirm': 'OK',
  'http.requestFailed': 'Request failed. Retry later.',
  'main.scanOnly': 'Please enter via QR code.',
  'main.walletOnly': 'Open in WeChat/Alipay+ app.'
}
